// extracted by mini-css-extract-plugin
export var container = "LanguageToggle-module--container--94910";
export var currentLanguage = "LanguageToggle-module--currentLanguage--beaed";
export var dropDown = "LanguageToggle-module--dropDown--b03a1";
export var footerChevron = "LanguageToggle-module--footerChevron--06c53";
export var footerLangIcon = "LanguageToggle-module--footerLangIcon--ca26b";